import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { colors } from 'Shared/util/theme';
import styles from './chart.css';


const generateChartData = (keys, values, label) => ({
  labels: keys,
  datasets: [{
    barPercentage: 1,
    categoryPercentage: 0.9,
    data: values,
    label,
    backgroundColor: colors.chart.third,
  }],
});


const BarChart = ({
  label,
  data,
  options,
  onElementsClick,
}) => {
  const handleOnElementsClick = (element, event) => ((!onElementsClick || !element[0]) ? {} : onElementsClick(element, event));

  const chartData = generateChartData(Object.keys(data), Object.values(data), label);

  return (
    <div className={styles.container}>
      <Bar
        data={chartData}
        options={options}
        onElementsClick={handleOnElementsClick}
      />
    </div>
  );
};

BarChart.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  onElementsClick: PropTypes.func,
};

export default BarChart;
